// @ts-check
import React from "react";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import { get } from "lodash";

const tagStoriesQuery = gql`
	query tagStoriesQuery($first: Int!, $tagId: ID) {
		tagStories(first: $first, tagId: $tagId) {
			id
			title
			slug
			summary
			publicationDate
			featuredImage {
                id
				url
			}
			author {
				id
				fullName
				slug
			}
		}
	}
`;

interface Props {
	children: ({ stories, loading }) => React.ReactElement;
	numStories: number;
	tagId?: string;
}

class TagStoriesQuery extends React.Component<Props> {

	parseData = data => ({
		stories: get(data, "tagStories", [])
	});

	render() {
		const { numStories, tagId } = this.props;
		return (
			<Query
				query={tagStoriesQuery}
				variables={{ first: numStories, tagId }}
				returnPartialData={true}
			>
				{({ loading, data }) => this.props.children({ ...this.parseData(data), loading })}
			</Query>
		);
	}
}

export default TagStoriesQuery;
